import { render, staticRenderFns } from "./carrierTab.vue?vue&type=template&id=be41b252&"
import script from "./carrierTab.vue?vue&type=script&lang=js&"
export * from "./carrierTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports